import {
  ProductSortOption,
  ProductSortOptionType,
  SearchProductType,
} from "~/modules/settings/types";

export const SEARCH_SORT_OPTIONS: ProductSortOption[] = [
  {
    label: "Relevance",
    value: ProductSortOptionType.relevance,
    appliedOnly: SearchProductType.searchPage,
  },
  {
    label: "Top products",
    value: ProductSortOptionType.top,
  },
  {
    label: "Position",
    value: ProductSortOptionType.position,
  },
  {
    label: "Price from high to low",
    value: ProductSortOptionType.price_desc,
  },
  {
    label: "Price from low to high",
    value: ProductSortOptionType.price_asc,
  },
];
